module.exports = __webpack_public_path__ + "static/media/hilltonelogo.ded8a1ea.png";